import React from 'react';
import { BaseButton, BaseButtonProps } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { Btn, CenteredRow } from './BaseButtonsGroup.styles';

interface BaseButtonsGroupProps extends BaseButtonProps {
  className?: string;
  onCancel: () => void;
  loading?: boolean;
  showCancel?: boolean; // New prop to control visibility of Cancel button
  showSave?: boolean;   // New prop to control visibility of Save button
  saveText?: string;
}

export const BaseButtonsGroup: React.FC<BaseButtonsGroupProps> = ({
  className,
  onCancel,
  loading,
  showCancel = true,
  showSave = true,
  saveText, // New prop
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CenteredRow className={className} gutter={[10, 10]} wrap={false} showCancel={showCancel} showSave={showSave}>
      {showCancel && (
        <BaseCol span={12}>
          <Btn type="ghost" onClick={onCancel} {...props}>
            {t('common.cancel')}
          </Btn>
        </BaseCol>
      )}
      {showSave && (
        <BaseCol span={12}>
          <Btn type="primary" loading={loading} htmlType="submit" {...props}>
          {saveText || t('common.save')} {/* Use saveText if provided, else default */}
          </Btn>
        </BaseCol>
      )}
   
    </CenteredRow>
  );
};
